import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=3cd271bb&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=ts"
export * from "./PermissionDenied.vue?vue&type=script&lang=ts"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=3cd271bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd271bb",
  null
  
)

export default component.exports